/**
 * @description: 商品销售汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-sxh-report">
        <div class="xh-list">
            <p class="p-hint">注：1、销售总量已扣除退款数量。2、日期选择一个营业日之内的话，时间点选择范围是：08：00到08：00之间。3、单价为商品设置的“优惠价”。4、销售总额=单价*销售数量</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="xhTime">
                        <input type="text" class="form-control laydate-icon" v-model="xhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="xhEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xhShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="xh_gtype_txt" ref="xh_gtype_txt" @click="xhGtypeFun($event)" readonly>
                    <span class="selection-clear" @click="clear_input">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4" v-show="xh_sortby != 'sales_type'">商品名称:</label>
                <div class="col-md-2" v-show="xh_sortby != 'sales_type'">
                    <input class="form-control" placeholder="请输入商品名称" v-model="goods_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4" v-show="xh_sortby == 'sales_store'">出货仓库:</label>
                <div class="col-md-2 ct-col" v-show="xh_sortby == 'sales_store'">
                    <select class="form-control" ref="xh_stock_input" data-placeholder="请选择出货仓库">
                    </select>
                </div>
                <label class="list-label-4" v-show="xh_sortby == 'sales_area'">包厢区域:</label>
                <div class="col-md-2 ct-col" v-show="xh_sortby == 'sales_area'">
                    <select class="form-control" ref="xh_area_input" data-placeholder="请选择包厢区域">
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4" ref="sale_total_label">销售总量:</label>
                <div class="list-total" ref="sale_total"></div>
                <label class="list-label-4">销售总额:</label>
                <div class="list-total" ref="sale_amount"></div>
                <div class="pull-right">
                    <button type="button" class="xh-sortby btn btn-flat btn-middle btn-border-orange btn-orange" @click="xhSortBy('sales')">按商品统计</button>
                    <button type="button" class="xh-sortby btn btn-flat btn-middle btn-border-gray" @click="xhSortBy('sales_store')">按出货仓库统计</button>
                    <button type="button" class="xh-sortby btn btn-flat btn-middle btn-border-gray" @click="xhSortBy('sales_area')">按区域统计</button>
                    <button type="button" class="xh-sortby btn btn-flat btn-middle btn-border-gray" @click="xhSortBy('sales_type')">按商品类型统计</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXhExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitXhTable">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix" v-if="xh_sortby == 'sales'">
                        <li>
                            <input type='checkbox' v-model='xhExport_allcheck1' @click='xhExportCheckedAll("sales")'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="discount_price">
                            <label>单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="price_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel1' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                    </ul>
                    <ul class="set-area clearfix" v-if="xh_sortby == 'sales_store'">
                        <li>
                            <input type='checkbox' v-model='xhExport_allcheck2' @click='xhExportCheckedAll("sales_store")'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="store_name">
                            <label>出货仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="discount_price">
                            <label>单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="price_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel2' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                    </ul>
                    <ul class="set-area clearfix" v-if="xh_sortby == 'sales_area'">
                        <li>
                            <input type='checkbox' v-model='xhExport_allcheck3' @click='xhExportCheckedAll("sales_area")'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="area_name">
                            <label>区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="discount_price">
                            <label>单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="price_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel3' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                    </ul>
                    <ul class="set-area clearfix" v-if="xh_sortby == 'sales_type'">
                        <li>
                            <input type='checkbox' v-model='xhExport_allcheck4' @click='xhExportCheckedAll("sales_area")'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel4' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel4' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel4' value="price_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xhExport_checkModel4' value="buying_price_total">
                            <label>进货总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix" v-if="xh_sortby == 'sales'">
                        <li>
                            <input type="radio" v-model='xhExport_type1' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xhExport_type1' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                    <ul class="clearfix" v-if="xh_sortby == 'sales_store'">
                        <li>
                            <input type="radio" v-model='xhExport_type2' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xhExport_type2' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                    <ul class="clearfix" v-if="xh_sortby == 'sales_area'">
                        <li>
                            <input type="radio" v-model='xhExport_type3' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xhExport_type3' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 商品类型弹窗 -->
            <div class="ele-hide" ref="xh_gtype_area">
                <div class="set-export sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xh_gtype_all' @click='xhGtypeAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in xh_gtype_data" :key="item.id">
                            <input type="checkbox" v-model='xh_gtype_item' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                goods_name: "",
                xhStartTime: "",
                xhEndTime: "",
                xh_gtype_txt: '',
                xh_gtype_all: false,
                c_xh_gtype_all: false,
                xh_gtype_data: [],
                xh_gtype_item: [],
                xhExport_allcheck1: false,
                c_xhExport_allcheck1: false,
                xhExport_allcheck2: false,
                c_xhExport_allcheck2: false,
                xhExport_allcheck3: false,
                c_xhExport_allcheck3: false,
                xhExport_allcheck4: false,
                c_xhExport_allcheck4: false,
                xhExport_checkModel1: [],
                xhExport_checkModel2: [],
                xhExport_checkModel3: [],
                xhExport_checkModel4: [],
                xhExport_checkData1: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'discount_price', 'quantity', 'price_total', 'buying_price', 'buying_price_total'],
                xhExport_checkData2: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'store_name', 'discount_price', 'quantity', 'price_total', 'buying_price', 'buying_price_total'],
                xhExport_checkData3: ['shop_name', 'area_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'discount_price', 'quantity', 'price_total', 'buying_price', 'buying_price_total'],
                xhExport_checkData4: ['shop_name', 'goods_type_name', 'price_total', 'buying_price_total'],
                xhExport_type1: 1,
                xhExport_type2: 1,
                xhExport_type3: 1,
                xhExport_type4: 1,
                xh_sortby: 'sales',
            }
        },
        watch: {
            xh_gtype_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.xh_gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.xh_gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            xh_gtype_item: {
                handler: function (val, oldVal) {
                    if(this.xh_gtype_item.length >= this.xh_gtype_data.length) {
                        this.xh_gtype_all = true;
                        this.c_xh_gtype_all = true;
                    } else {
                        this.xh_gtype_all = false;
                        this.c_xh_gtype_all = false;
                    }
                },
                deep: true
            },
            xhExport_checkModel1: {
                handler: function(val, oldVal) {
                    if(this.xhExport_checkModel1.length >= this.xhExport_checkData1.length) {
                        this.xhExport_allcheck1 = true;
                        this.c_xhExport_allcheck1 = true;
                    } else {
                        this.xhExport_allcheck1 = false;
                        this.c_xhExport_allcheck1 = false;
                    }
                },
                deep: true
            },
            xhExport_checkModel2: {
                handler: function(val, oldVal) {
                    if(this.xhExport_checkModel2.length >= this.xhExport_checkData2.length) {
                        this.xhExport_allcheck2 = true;
                        this.c_xhExport_allcheck2 = true;
                    } else {
                        this.xhExport_allcheck2 = false;
                        this.c_xhExport_allcheck2 = false;
                    }
                },
                deep: true
            },
            xhExport_checkModel3: {
                handler: function (val, oldVal) {
                    if(this.xhExport_checkModel3.length >= this.xhExport_checkData3.length) {
                        this.xhExport_allcheck3 = true;
                        this.c_xhExport_allcheck3 = true;
                    } else {
                        this.xhExport_allcheck3 = false;
                        this.c_xhExport_allcheck3 = false;
                    }
                },
                deep: true
            },
            xhExport_checkModel4: {
                handler: function (val, oldVal) {
                    if(this.xhExport_checkModel4.length >= this.xhExport_checkData4.length) {
                        this.xhExport_allcheck4 = true;
                        this.c_xhExport_allcheck4 = true;
                    } else {
                        this.xhExport_allcheck4 = false;
                        this.c_xhExport_allcheck4 = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.xhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.xhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.typeList = [];
            this.getGoodsType();  // 商品类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.xhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.xhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.xhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').hour(8).minute(0).toDate(),
                    endDate: moment().hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    if(end.diff(start) > 86400000) {
                        _this.xhStartTime = start.format('YYYY-MM-DD 08:00');
                        _this.xhEndTime = end.format('YYYY-MM-DD 08:00');
                    } else {
                        _this.xhStartTime = start.format('YYYY-MM-DD HH:mm');
                        _this.xhEndTime = end.format('YYYY-MM-DD HH:mm');
                    }
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.xhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.xh_stock_input).prop("disabled", true);
                                    $(_this.$refs.xh_area_input).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.xh_stock_input).prop("disabled", false);
                                $(_this.$refs.xh_area_input).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                                _this.getRoomArea(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.xhShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitXhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let xh_area_data = [{id: ' ', text: '全部'}];
                            $.each(data.response.result, function(k, v) {
                                xh_area_data.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xh_area_input).html("");
                            $(_this.$refs.xh_area_input).select2({
                                data: xh_area_data,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 仓库
            getstockdata: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xh_stock_input).html("");
                            $(_this.$refs.xh_stock_input).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {

                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            result.unshift({ id: "0", name: "全部" });
                            $.each(result, function(k, v) {
                                _this.typeList.push({ id: v.id, text: v.name });
                            });
                            result.shift();
                            _this.xh_gtype_data = result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 清空多选
            clear_input: function() {
                this.xh_gtype_txt = "";
                this.xh_gtype_item = [];
            },



            // 商品类型弹窗
            xhGtypeFun: function(e) {
                let _this = this;
                let c_xh_gtype_item = _this.xh_gtype_item;
                layer.confirm('', {
                    skin: 'timing_room_type',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['660', ''], // 宽高
                    content: $(_this.$refs.xh_gtype_area),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.xh_gtype_txt != "") {
                            _this.xh_gtype_item = c_xh_gtype_item;
                            return;
                        }
                        _this.xh_gtype_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.xh_gtype_data.forEach(function(item) {
                        _this.xh_gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.xh_gtype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.xh_gtype_txt != "") {
                        _this.xh_gtype_item = c_xh_gtype_item;
                        return;
                    }
                    _this.xh_gtype_item = [];
                });
            },
            // 全选
            xhGtypeAll: function() {
                let _this = this;
                _this.xh_gtype_all = _this.c_xh_gtype_all;
                if(!_this.xh_gtype_all) { // 实现全选
                    _this.xh_gtype_item = [];
                    _this.xh_gtype_data.forEach(function(item) {
                        _this.xh_gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.xh_gtype_item = [];
                }
            },
            // 商品销售汇总报表表格
            innitXhTable: function() {
                let _this = this;
                $(_this.$refs.xhList).bootstrapTable("destroy");
                $(_this.$refs.xhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getXhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "area_name",
                        title: "区域",
                        width: "5%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "7%"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "15%"
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%"
                    }, {
                        field: "store_name",
                        title: "出货仓库",
                        width: "5%"
                    }, {
                        field: "discount_price",
                        title: "单价",
                        width: "8%"
                    }, {
                        field: "quantity",
                        title: "销售数量",
                        width: "8%"
                    }, {
                        field: "price_total",
                        title: "销售总额",
                        width: "8%"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "8%"
                    }, {
                        field: "buying_price_total",
                        title: "进货总额",
                        width: "8%"
                    }],
                });
                if(_this.xh_sortby != 'sales_area') {
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'area_name');
                }
                if(_this.xh_sortby != 'sales_store') {
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'store_name');
                }
                if(_this.xh_sortby == 'sales_type') {
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'goods_name');
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'goods_unit_name');
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'discount_price');
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'quantity');
                    $(_this.$refs.xhList).bootstrapTable('hideColumn', 'buying_price');
                }
            },
            // 获取商品销售汇总报表
            getXhList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.xhShop).val(),
                    pageNumber = 1,
                    url = '';
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if(_this.xh_sortby == 'sales') {
                    url = Vue.ctUrl + 'FinanceReport/getGoodsSalesSumList';
                } else if(_this.xh_sortby == 'sales_store') {
                    url = Vue.ctUrl + 'FinanceReport/getGoodsSalesSumListByStore';
                } else if(_this.xh_sortby == 'sales_area') {
                    url = Vue.ctUrl + 'FinanceReport/getGoodsSalesSumListByRoomArea';
                } else if(_this.xh_sortby == 'sales_type') {
                    url = Vue.ctUrl + 'FinanceReport/getGoodsSalesSumListByGoodsType';
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.xhStartTime,
                            "end_date": _this.xhEndTime,
                            "shop_id": shop_id,
                            "goods_type": _this.xh_gtype_item
                        }
                    },
                    "comment": ""
                };
                if(_this.xh_sortby == 'sales_store') {
                    datas["request"]["param"]["store_id"] = $.trim($(_this.$refs.xh_stock_input).val());
                }
                if(_this.xh_sortby == 'sales_area') {
                    datas["request"]["param"]["room_area"] = $.trim($(_this.$refs.xh_area_input).val());
                }
                if(_this.xh_sortby != 'sales_type') {
                    datas["request"]["param"]["goods_name"] = _this.goods_name
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                            if (pageNumber == 1) {
                                if(_this.xh_sortby != 'sales_type') {
                                    $(_this.$refs.sale_total).show().text(data.response.result.total_quantity);
                                    $(_this.$refs.sale_total_label).show();
                                }else {
                                    $(_this.$refs.sale_total).hide();
                                    $(_this.$refs.sale_total_label).hide();
                                }
                                $(_this.$refs.sale_amount).text(data.response.result.price_total);
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getXhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/sumCommonExport?bill_type=" + _this.xh_sortby
                        }
                    },
                    "comment": ""
                };
                if(_this.xh_sortby == 'sales_area') {
                    datas.request.param.report_type = 'FinanceReport/getGoodsSalesSumListByRoomAreaExport';
                }
                if(_this.xh_sortby == 'sales_type') {
                    datas.request.param.report_type = 'FinanceReport/sumCommonExport';
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                if(_this.xh_sortby == 'sales') {
                                    _this.xhExport_checkModel1 = data.response.result.export_fields;
                                    _this.xhExport_type1 = data.response.result.export_type;
                                } else if(_this.xh_sortby == 'sales_store') {
                                    _this.xhExport_checkModel2 = data.response.result.export_fields;
                                    _this.xhExport_type2 = data.response.result.export_type;
                                } else if(_this.xh_sortby == 'sales_area') {
                                    _this.xhExport_checkModel3 = data.response.result.export_fields;
                                    _this.xhExport_type3 = data.response.result.export_type;
                                } else if(_this.xh_sortby == 'sales_type') {
                                    _this.xhExport_checkModel4 = data.response.result.export_fields;
                                    _this.xhExport_type4 = data.response.result.export_type;
                                }
                            } else {
                                if(_this.xh_sortby == 'sales') {
                                    _this.xhExport_checkModel1 = _this.xhExport_checkData1;
                                    _this.xhExport_type1 = 1;
                                } else if(_this.xh_sortby == 'sales_store') {
                                    _this.xhExport_checkModel2 = _this.xhExport_checkData2;
                                    _this.xhExport_type2 = 1;
                                } else if(_this.xh_sortby == 'sales_area') {
                                    _this.xhExport_checkModel3 = _this.xhExport_checkData3;
                                    _this.xhExport_type3 = 1;
                                } else if(_this.xh_sortby == 'sales_type') {
                                    _this.xhExport_checkModel4 = _this.xhExport_checkData4;
                                    _this.xhExport_type4 = 1;
                                }
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xhExport_alert)
                }, function() {
                    _this.exportXhList();
                });
            },
            // 导出字段全选
            xhExportCheckedAll: function(type) {
                let _this = this;
                if(type == 'sales') {
                    _this.xhExport_allcheck1 = _this.c_xhExport_allcheck1;
                    if(!_this.xhExport_allcheck1) { // 实现全选
                        _this.xhExport_checkModel1 = [];
                        _this.xhExport_checkData1.forEach(function(item) {
                            _this.xhExport_checkModel1.push(item);
                        });
                    } else { // 实现反选
                        _this.xhExport_checkModel1 = [];
                    }
                } else if(type == 'sales_store') {
                    _this.xhExport_allcheck2 = _this.c_xhExport_allcheck2;
                    if(!_this.xhExport_allcheck2) { // 实现全选
                        _this.xhExport_checkModel2 = [];
                        _this.xhExport_checkData2.forEach(function(item) {
                            _this.xhExport_checkModel2.push(item);
                        });
                    } else { // 实现反选
                        _this.xhExport_checkModel2 = [];
                    }
                } else if(type == 'sales_area') {
                    _this.xhExport_allcheck3 = _this.c_xhExport_allcheck3;
                    if(!_this.xhExport_allcheck3) { // 实现全选
                        _this.xhExport_checkModel3 = [];
                        _this.xhExport_checkData3.forEach(function(item) {
                            _this.xhExport_checkModel3.push(item);
                        });
                    } else { // 实现反选
                        _this.xhExport_checkModel3 = [];
                    }
                } else if(type == 'sales_type') {
                    _this.xhExport_allcheck4 = _this.c_xhExport_allcheck4;
                    if(!_this.xhExport_allcheck4) { // 实现全选
                        _this.xhExport_checkModel4 = [];
                        _this.xhExport_checkData4.forEach(function(item) {
                            _this.xhExport_checkModel4.push(item);
                        });
                    } else { // 实现反选
                        _this.xhExport_checkModel4 = [];
                    }
                }
            },
            // 点击“导出”按钮
            exportXhList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.xhShop).val();
                if(_this.xh_sortby == 'sales') {
                    let export_fields = JSON.stringify(_this.xhExport_checkModel1);
                    window.location.href = Vue.ctUrl + "FinanceReport/sumCommonExport?bill_type=" + _this.xh_sortby +
                        "&start_date=" + _this.xhStartTime +
                        "&end_date=" + _this.xhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.xh_gtype_item +
                        "&goods_name=" + _this.goods_name +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.xhExport_type1;
                } else if(_this.xh_sortby == 'sales_store') {
                    let export_fields = JSON.stringify(_this.xhExport_checkModel2);
                    window.location.href = Vue.ctUrl + "FinanceReport/sumCommonExport?bill_type=" + _this.xh_sortby +
                        "&start_date=" + _this.xhStartTime +
                        "&end_date=" + _this.xhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.xh_gtype_item +
                        "&goods_name=" + _this.goods_name +
                        "&store_id=" + $.trim($(_this.$refs.xh_stock_input).val()) +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.xhExport_type2;
                } else if(_this.xh_sortby == 'sales_area') {
                    let export_fields = JSON.stringify(_this.xhExport_checkModel3);
                    window.location.href = Vue.ctUrl + "FinanceReport/getGoodsSalesSumListByRoomAreaExport" +
                        "?start_date=" + _this.xhStartTime +
                        "&end_date=" + _this.xhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.xh_gtype_item +
                        "&goods_name=" + _this.goods_name +
                        "&room_area=" + $.trim($(_this.$refs.xh_area_input).val()) +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.xhExport_type3;
                } else if(_this.xh_sortby == 'sales_type') {
                    let export_fields = JSON.stringify(_this.xhExport_checkModel4);
                    window.location.href = Vue.ctUrl + "FinanceReport/sumCommonExport?bill_type=sales_goods_type" +
                        "&start_date=" + _this.xhStartTime +
                        "&end_date=" + _this.xhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.xh_gtype_item +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.xhExport_type4;
                }
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 统计方式
            xhSortBy: function(type) {
                let _this = this;
                $('.xh-sortby').removeClass('btn-orange');
                $('.xh-sortby').removeClass('btn-border-orange');
                $('.xh-sortby').removeClass('btn-border-gray');
                _this.xh_sortby = type;

                if(type == 'sales') {
                    $('.xh-sortby').eq(0).addClass('btn-orange');
                    $('.xh-sortby').eq(0).addClass('btn-border-orange');
                    $('.xh-sortby').eq(1).addClass('btn-border-gray');
                    $('.xh-sortby').eq(2).addClass('btn-border-gray');
                    $('.xh-sortby').eq(3).addClass('btn-border-gray');
                } else if(type == 'sales_store') {
                    $('.xh-sortby').eq(0).addClass('btn-border-gray');
                    $('.xh-sortby').eq(1).addClass('btn-orange');
                    $('.xh-sortby').eq(1).addClass('btn-border-orange');
                    $('.xh-sortby').eq(2).addClass('btn-border-gray');
                    $('.xh-sortby').eq(3).addClass('btn-border-gray');

                    $(_this.$refs.xh_stock_input).val('').trigger('change');
                    if($(_this.$refs.xhShop).val() == "0") {
                        $(_this.$refs.xh_stock_input).prop("disabled", true);
                    } else {
                        $(_this.$refs.xh_stock_input).prop("disabled", false);
                        _this.getstockdata($(_this.$refs.xhShop).val());
                    }
                } else if(type == 'sales_area') {
                    $('.xh-sortby').eq(0).addClass('btn-border-gray');
                    $('.xh-sortby').eq(1).addClass('btn-border-gray');
                    $('.xh-sortby').eq(2).addClass('btn-orange');
                    $('.xh-sortby').eq(2).addClass('btn-border-orange');
                    $('.xh-sortby').eq(3).addClass('btn-border-orange');

                    $(_this.$refs.xh_area_input).val('').trigger('change');
                    if($(_this.$refs.xhShop).val() == "0") {
                        $(_this.$refs.xh_area_input).prop("disabled", true);
                    } else {
                        $(_this.$refs.xh_area_input).prop("disabled", false);
                        _this.getRoomArea($(_this.$refs.xhShop).val());
                    }
                } else if(type == 'sales_type') {
                    $('.xh-sortby').eq(0).addClass('btn-border-gray');
                    $('.xh-sortby').eq(1).addClass('btn-border-gray');
                    $('.xh-sortby').eq(2).addClass('btn-border-gray');
                    $('.xh-sortby').eq(3).addClass('btn-orange');
                    $('.xh-sortby').eq(3).addClass('btn-border-orange');

                    _this.goods_name = ''
                }
                $(_this.$refs.xhList).bootstrapTable("destroy");
                _this.innitXhTable();
            },
        }
    }
</script>
<style lang="less" scoped>
    .xh-list {
        .pull-right {
            button {
                margin-left: 10px;
            }
        }
    }
</style>